import { createLocalStorageStateHook } from 'use-local-storage-state';
import Themes from 'lib/constants/Themes';

const useCachedSelectedTheme = createLocalStorageStateHook(
  'selected-theme',
  Themes.LIGHT
);

export default useCachedSelectedTheme;
